var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-2"},[_c('button',{staticClass:"link_btn color_interactive-4 pointer",on:{"click":_vm.toggleTable}},[_vm._v("metody i właściwości")])]),_c('s-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.isTableVisible),expression:"isTableVisible"}],attrs:{"tableData":_vm.tableData,"cssClasses":{
			table: 'table full_width table_style-docs',
			thead: 'border_bottom'
		}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }